module.exports = __webpack_public_path__ + "static/dashboard_report2@2x-927b7ad6fabfd6ae3665ccb134968b6e.png";